import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    delete: 'Delete',
    title: 'Uploaded on {createdAt}',
  },
  fr: {
    delete: 'Supprimer',
    title: 'Téléchargé le {createdAt}',
  },
} as const);

export default locales;
